// shadi-arts-portfolio Firebase\client\src\components\Admin\DashboardStats.jsx

import React, { useState, useEffect } from "react";
import { db } from "../../firebase";
import { collection, getDocs } from "firebase/firestore";
import { useLanguage } from "../../context/LanguageContext";

const DashboardStats = () => {
  const { t } = useLanguage();
  const [stats, setStats] = useState({
    totalOrders: 0,
    pendingOrders: 0,
    totalRevenue: 0,
    totalArtworks: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        // Fetch orders
        const ordersSnapshot = await getDocs(collection(db, "orders"));
        const orders = ordersSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const pendingOrders = orders.filter(
          (order) => order.status?.order === "pending",
        ).length;
        const totalRevenue = orders.reduce(
          (sum, order) => sum + (order.pricing?.estimated || 0),
          0,
        );

        // Fetch artworks
        const artworksSnapshot = await getDocs(collection(db, "artworks"));
        const totalArtworks = artworksSnapshot.size;

        setStats({
          totalOrders: orders.length,
          pendingOrders,
          totalRevenue,
          totalArtworks,
        });
      } catch (error) {
        console.error("Error fetching stats:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return (
      <div className="stats-loading">
        {t("Loading stats...", "جاري تحميل الإحصائيات...")}
      </div>
    );
  }

  return (
    <div className="dashboard-stats">
      <div className="stat-card gold-glow">
        <div className="stat-icon">📦</div>
        <div className="stat-info">
          <h3>{t("Total Orders", "إجمالي الطلبات")}</h3>
          <p className="stat-number">{stats.totalOrders}</p>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon">⏳</div>
        <div className="stat-info">
          <h3>{t("Pending Orders", "الطلبات المعلقة")}</h3>
          <p className="stat-number">{stats.pendingOrders}</p>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon">💰</div>
        <div className="stat-info">
          <h3>{t("Total Revenue", "إجمالي الإيرادات")}</h3>
          <p className="stat-number">
            EGP {stats.totalRevenue.toLocaleString()}
          </p>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon">🖼️</div>
        <div className="stat-info">
          <h3>{t("Artworks", "الأعمال الفنية")}</h3>
          <p className="stat-number">{stats.totalArtworks}</p>
        </div>
      </div>
    </div>
  );
};

export default DashboardStats;
